import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-10 w-10 border-4 border-amber border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role) && !(roles.includes("institute") && user.is_institute)) {
    const home = { super_admin: "/admin", admin: "/admin", sub_admin: "/admin", educator: "/educator", content_seller: "/seller", institute: "/institute", learner: "/learner" }[user.role] || "/";
    return <Navigate to={home} replace />;
  }
  return children;
}
